import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SpeechEmbed from "./SpeechEmbed";
import { Button } from "antd";

const SpeechReportPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const speech = location.state;

  if (!speech) {
    return <div>No speech file found.</div>;
  }

  return (
    <div>
      <Button onClick={() => navigate(-1)} style={{ margin: "1rem" }}>
        ← Back
      </Button>
      <SpeechEmbed fileUrl={speech.fileUrl} />
    </div>
  );
};

export default SpeechReportPage;
